import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgChatsCircle = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M25.383 20.427A8.75 8.75 0 0 0 18.547 7.94a8.75 8.75 0 1 0-15.93 7.237l-.795 2.703a1.75 1.75 0 0 0 2.173 2.173l2.703-.795a8.794 8.794 0 0 0 2.754.804 8.75 8.75 0 0 0 11.85 4.446l2.703.795a1.75 1.75 0 0 0 2.173-2.172l-.795-2.704ZM6.78 17.445a.907.907 0 0 0-.247.035l-3.034.895.894-3.036a.875.875 0 0 0-.07-.657 7 7 0 1 1 2.873 2.873.876.876 0 0 0-.416-.11Zm16.821 3.143.898 3.037-3.036-.894a.876.876 0 0 0-.656.07 7.005 7.005 0 0 1-9.393-2.722 8.742 8.742 0 0 0 7.693-10.267 6.999 6.999 0 0 1 4.566 10.115.875.875 0 0 0-.069.66h-.003Z" />
  </svg>
);
export default SvgChatsCircle;
